import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "touristsubjectline",
  inputs: [
    {
      name: "full_name",
      label: "Name",
      placeholder: "Ankita Chaudhary",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "visa_type",
      label: "For which visa you have applied for ?",
      placeholder: "Tourist visa ",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Canada",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "starting_date",
      label: "Your journey begins on",
      placeholder: "1 March 2023",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "ending_date",
      label: "Your journey ends on",
      placeholder: "31 March 2023",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
    {
      name: "purpose",
      label: "For what purpose you are travelling?",
      placeholder: "Family Visit ",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
    },
  ],
};

export default formFields;
